import { j as o } from "../../jsx-runtime-82a9ddf6.js";
import { cn as t } from "../../lib/cn.js";
/* empty css                    */import "../button/index.js";
import "../checkbox/index.js";
import "../spin/index.js";
import { Typography as s } from "../typography/index.js";
import "react";
import "../alert/index.js";
import "../../ReactCodeInput-cc430180.js";
import "../tooltip/index.js";
import "../dropdown/index.js";
/* empty css                    */import "../badge/index.js";
import "../switcher/index.js";
import "../toast/index.js";
import "../../react-toastify.esm-a636d9b1.js";
const v = ({ children: i, title: r, className: m, padding: p = !0 }) => /* @__PURE__ */ o.jsxs("div", { className: t("bg-white dark:bg-slate-800 rounded-lg shadow-sm", p && "p-5", m), children: [
  !!r && /* @__PURE__ */ o.jsx(s, { weight: "bold", size: "base", className: "leading-[17px] mb-4 whitespace-nowrap", children: r }),
  i
] });
export {
  v as Card
};
